<smart-cart-form-token-section [token]="usageToken"></smart-cart-form-token-section>

<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <div class="card__title-block">
        <pdq-heading element="h5">Display text</pdq-heading>
      </div>
      <div class="card__actions">
        <pdq-button
          class="collapse-chevron"
          [class.collapse-chevron--open]="displayTextExpanded"
          icon="arrow_down"
          variant="ghost"
          plain="true"
          size="large"
          iconColor="var(--on-surface-default)"
          (onClick)="toggleDisplayText()"></pdq-button>
      </div>
    </div>
    @if (displayTextExpanded) {
      <pdq-divider></pdq-divider>
      <div class="card__content">
        <div class="field">
          <div class="message-header">
            <span class="field__label message-header__label">Empty cart text</span>
            <pdq-button
              variant="empty"
              [icon]="showEmptyCartPreview() ? 'preview_eye' : 'preview_eye_crossed'"
              [iconColor]="showEmptyCartPreview() ? 'var(--primary-default)' : 'var(--on-surface-light)'"
              (onClick)="toggleEmptyCartPreview()"></pdq-button>
          </div>
          <rich-textarea
            [initialContent]="formGroup.controls.emptyCartText.value"
            (contentChange)="onEmptyCartTextChange($event)"
            [enableLinkInsert]="true"
            placeholder="Your cart is empty!"></rich-textarea>
        </div>
        <pdq-input-color
          [formControl]="formGroup.controls.emptyCartTextColor"
          label="Text Color"
          [clearable]="true"
          clearTooltip="Reset to the default colour"
          (cleared)="formGroup.controls.emptyCartTextColor.setValue('')"></pdq-input-color>
      </div>
    }
  </div>
</pdq-card>

<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <div class="card__title-block">
        <pdq-heading element="h5">Product Image</pdq-heading>
        <span class="card__subtitle">Size and framing of the product photo on every cart item</span>
      </div>
      <div class="card__actions">
        <pdq-button
          class="collapse-chevron"
          [class.collapse-chevron--open]="productImageExpanded"
          icon="arrow_down"
          variant="ghost"
          plain="true"
          size="large"
          iconColor="var(--on-surface-default)"
          (onClick)="toggleProductImage()"></pdq-button>
      </div>
    </div>
    @if (productImageExpanded) {
      <pdq-divider></pdq-divider>
      <div class="card__content">
        <div class="field">
          <span class="field__label">Fit</span>
          <pdq-dropdown
            [formControl]="formGroup.controls.image.controls.fit"
            [options]="imageFitOptions"
            fullWidth="true"></pdq-dropdown>
        </div>

        <!--
          [min] is 0, not the real 64 floor: pdq-input-arrows clamps to [min] on every keystroke, so a
          64 floor rewrites the first digit you type (1 -> 64) and typing a value like 140 is impossible.
          0 keeps the steppers from going negative while leaving typing free; the real bounds are enforced
          by the control's validators (message below) and clamped again by the storefront.
        -->
        <div class="field-row">
          <div class="field">
            <span class="field__label">Width</span>
            <pdq-input-arrows
              [formControl]="formGroup.controls.image.controls.width"
              widthSize="fullwidth"
              [min]="0"
              [max]="imageBounds.width.max"
              placeholder="104"></pdq-input-arrows>
          </div>
          <div class="field">
            <span class="field__label">Height</span>
            <pdq-input-arrows
              [formControl]="formGroup.controls.image.controls.height"
              widthSize="fullwidth"
              [min]="0"
              [max]="imageBounds.height.max"
              placeholder="130"></pdq-input-arrows>
          </div>
        </div>
        @if (formGroup.controls.image.controls.width.invalid || formGroup.controls.image.controls.height.invalid) {
          <span class="field__error">
            Width must be {{ imageBounds.width.min }}–{{ imageBounds.width.max }}px and height
            {{ imageBounds.height.min }}–{{ imageBounds.height.max }}px.
          </span>
        }

        <pdq-input-color
          [formControl]="formGroup.controls.image.controls.backgroundColor"
          label="Background Color"
          [clearable]="true"
          clearTooltip="Reset to the default colour"
          (cleared)="
            formGroup.controls.image.controls.backgroundColor.setValue(defaultImageBackground)
          "></pdq-input-color>
      </div>
    }
  </div>
</pdq-card>

<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <div class="card__title-block">
        <pdq-heading element="h5">Quantity Input</pdq-heading>
        <span class="card__subtitle">Quantity controls on cart items</span>
      </div>
      <div class="card__actions">
        <pdq-button
          class="collapse-chevron"
          [class.collapse-chevron--open]="quantityInputExpanded"
          icon="arrow_down"
          variant="ghost"
          plain="true"
          size="large"
          iconColor="var(--on-surface-default)"
          (onClick)="toggleQuantityInput()"></pdq-button>
      </div>
    </div>
    @if (quantityInputExpanded) {
      <pdq-divider></pdq-divider>
      <div class="card__content">
        <div class="field-row">
          <div class="field">
            <span class="field__label">Minimum Quantity Value</span>
            <pdq-input-arrows
              [formControl]="formGroup.controls.quantityInput.controls.min"
              widthSize="fullwidth"
              [min]="0"
              [max]="999"
              placeholder="0"></pdq-input-arrows>
          </div>
          <div class="field">
            <span class="field__label">Maximum Quantity Value</span>
            <pdq-input-arrows
              [formControl]="formGroup.controls.quantityInput.controls.max"
              widthSize="fullwidth"
              [min]="1"
              [max]="1000"
              placeholder="10"></pdq-input-arrows>
          </div>
        </div>
        @if (formGroup.controls.quantityInput.errors?.['minGreaterThanMax']) {
          <span class="field__error">Maximum value must be greater than or equal to minimum value.</span>
        }

        <div class="field">
          <span class="field__label">Quantity Input Type</span>
          <pdq-dropdown
            [formControl]="formGroup.controls.quantityInput.controls.inputType"
            [options]="quantityInputTypeOptions"
            fullWidth="true"></pdq-dropdown>
        </div>

        <div class="field">
          <span class="field__label">Quantity Position</span>
          <pdq-dropdown
            [formControl]="formGroup.controls.quantityInput.controls.position"
            [options]="quantityPositionOptions"
            fullWidth="true"></pdq-dropdown>
        </div>

        <div class="subsection">
          <div class="subsection__header">
            <span class="subsection__label">ERROR MESSAGES</span>
            <pdq-button
              class="collapse-chevron"
              [class.collapse-chevron--open]="errorMessagesExpanded"
              icon="arrow_down"
              variant="ghost"
              plain="true"
              size="large"
              iconColor="var(--on-surface-default)"
              (onClick)="toggleErrorMessages()"></pdq-button>
          </div>
          @if (errorMessagesExpanded) {
            <div class="field">
              <span class="field__label">Minimum Quantity Message</span>
              <pdq-input
                [formControl]="formGroup.controls.quantityInput.controls.minQuantityMessage"
                [placeholder]="'Min Qty of {min}'"></pdq-input>
              <span class="field__hint">Dynamic field available - {{ '{min}' }} - The minimum quantity value</span>
            </div>
            <div class="field">
              <span class="field__label">Maximum Quantity Message</span>
              <pdq-input
                [formControl]="formGroup.controls.quantityInput.controls.maxQuantityMessage"
                [placeholder]="'Max Qty of {max}'"></pdq-input>
              <span class="field__hint">Dynamic field available - {{ '{max}' }} - The maximum quantity value</span>
            </div>
          }
        </div>
      </div>
    }
  </div>
</pdq-card>

<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <div class="card__title-block">
        <pdq-heading element="h5">Switch to Subscription</pdq-heading>
      </div>
      <div class="card__actions">
        <pdq-slide-toggle
          [defaultValue]="formGroup.controls.subscription.controls.enabled.value"
          (onToggle)="formGroup.controls.subscription.controls.enabled.setValue($event)"></pdq-slide-toggle>
        <pdq-button
          class="collapse-chevron"
          [class.collapse-chevron--open]="subscriptionExpanded"
          icon="arrow_down"
          variant="ghost"
          plain="true"
          size="large"
          iconColor="var(--on-surface-default)"
          (onClick)="toggleSubscription()"></pdq-button>
      </div>
    </div>
    @if (subscriptionExpanded) {
      <pdq-divider></pdq-divider>
      <div class="card__content">
        <pdq-radio-group [formControl]="formGroup.controls.subscription.controls.selectorType" alignment="vertical">
          <pdq-radio-button value="dropdown" text="Default selector (only dropdown field)"></pdq-radio-button>
          <pdq-radio-button value="upgrade_button" text="'Upgrade to' button"></pdq-radio-button>
        </pdq-radio-group>
        @if (formGroup.controls.subscription.controls.selectorType.value === 'upgrade_button') {
          <div class="field">
            <span class="field__label">Label</span>
            <pdq-input
              [formControl]="formGroup.controls.subscription.controls.label"
              [placeholder]="'Subscribe & Save {subscription_discount}%'"></pdq-input>
            <span class="field__hint">Dynamic field available - {{ '{subscription_discount}' }}</span>
          </div>
          <div class="field">
            <span class="field__label">Upgrading Label</span>
            <pdq-input
              [formControl]="formGroup.controls.subscription.controls.upgradingLabel"
              placeholder="Upgrading..."></pdq-input>
          </div>
        }
        <div class="subsection">
          <div class="subsection__header">
            <span class="subsection__label">DESIGN</span>
            <pdq-button
              class="collapse-chevron"
              [class.collapse-chevron--open]="subscriptionDesignExpanded"
              icon="arrow_down"
              variant="ghost"
              plain="true"
              size="large"
              iconColor="var(--on-surface-default)"
              (onClick)="toggleSubscriptionDesign()"></pdq-button>
          </div>
          @if (subscriptionDesignExpanded) {
            <div class="subsection__content">
              <div class="field">
                <div class="field__label-row">
                  <span class="field__label">Background Color</span>
                  @if (backgroundColorOverridden()) {
                    <pdq-link
                      label="Reset to global color"
                      size="small"
                      (onClick)="
                        resetToGlobal(formGroup.controls.subscription.controls.design.controls.backgroundColor)
                      "></pdq-link>
                  }
                </div>
                <pdq-input-color [formControl]="displayBackgroundColor"></pdq-input-color>
              </div>
              <div class="field">
                <div class="field__label-row">
                  <span class="field__label">Text Color</span>
                  @if (textColorOverridden()) {
                    <pdq-link
                      label="Reset to global color"
                      size="small"
                      (onClick)="
                        resetToGlobal(formGroup.controls.subscription.controls.design.controls.textColor)
                      "></pdq-link>
                  }
                </div>
                <pdq-input-color [formControl]="displayTextColor"></pdq-input-color>
              </div>
              <div class="field">
                <div class="field__label-row">
                  <span class="field__label">Hover Color</span>
                  @if (hoverColorOverridden()) {
                    <pdq-link
                      label="Reset to global color"
                      size="small"
                      (onClick)="
                        resetToGlobal(formGroup.controls.subscription.controls.design.controls.hoverColor)
                      "></pdq-link>
                  }
                </div>
                <pdq-input-color [formControl]="displayHoverColor"></pdq-input-color>
              </div>
              @if (formGroup.controls.subscription.controls.selectorType.value !== 'upgrade_button') {
                <div class="field">
                  <div class="field__label-row">
                    <span class="field__label">Icon Color</span>
                    @if (iconColorOverridden()) {
                      <pdq-link
                        label="Reset to global color"
                        size="small"
                        (onClick)="
                          resetToGlobal(formGroup.controls.subscription.controls.design.controls.iconColor)
                        "></pdq-link>
                    }
                  </div>
                  <pdq-input-color [formControl]="displayIconColor"></pdq-input-color>
                </div>
              }
              <div class="field">
                <div class="field__label-row">
                  <span class="field__label">Corner Radius</span>
                  @if (cornerRadiusOverridden()) {
                    <pdq-link
                      label="Reset to global number"
                      size="small"
                      (onClick)="
                        resetToGlobal(formGroup.controls.subscription.controls.design.controls.cornerRadius)
                      "></pdq-link>
                  }
                </div>
                <pdq-input-arrows
                  [formControl]="displayCornerRadius"
                  [min]="0"
                  widthSize="fullwidth"></pdq-input-arrows>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</pdq-card>

<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header card__header--standalone">
      <div class="card__title-block">
        <pdq-heading element="h5">Change Variant</pdq-heading>
      </div>
      <div class="card__actions">
        <pdq-slide-toggle
          [defaultValue]="formGroup.controls.changeVariant.value"
          (onToggle)="formGroup.controls.changeVariant.setValue($event)"></pdq-slide-toggle>
      </div>
    </div>
  </div>
</pdq-card>

<smart-cart-form-custom-code
  [enabledControl]="formGroup.controls.customCode.controls.enabled"
  [codeControl]="formGroup.controls.customCode.controls.code"
  [defaultCode]="starterTemplate"
  [variables]="customCodeVariables"></smart-cart-form-custom-code>
